module.exports = __webpack_public_path__ + "static/img/复旦大学附属华东医院.5e157bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/复旦大学附属华东医院.png
// module id = 8eP1
// module chunks = 0 1 2 9